import { useState } from 'react'

export const useForm = (initialValues) => {
  const [val, setVal] = useState(initialValues)

  return {
    val,
    handleChange: (e) => {
      setVal({
        ...val,
        [e.target.name]: e.target.value
      })
    },
    reset: () => setVal(initialValues)
  }
}

export default useForm
